import React from 'react'
import { Button, theme } from '@provi/provi-components'
import {
  ItemInvoice,
  Left,
  Text,
  Footer,
  TextTitle,
  TextSimple,
  Right,
  Status,
  Header,
  Center,
  WarningText,
  Br
} from '../styles'
import { Hr } from '../../../../../components/horizontal-row'

export const ActiveDelayedInvoice = ({ item, getInvoice, formattedPrice, dueDate }) => (
  <ItemInvoice active>
    <Header>
      <Left>
        <TextTitle>{formattedPrice}</TextTitle>
        <TextSimple>Vencimento: {dueDate}</TextSimple>
      </Left>
      <Right>
        <Text>Fatura atrasada</Text>
        <Status color={theme.colors.pink900} />
      </Right>
    </Header>

    <Footer>
      <Left>
        <Button onClick={() => getInvoice(item)} text={`${item.InvoiceId ? 'Gerar 2º via' : 'Pagar agora'}`} />
      </Left>
      <Right>
        <Text>{item.isUpfront ? 'Entrada' : `${item.number}/${item.amountOfItems}`}</Text>
      </Right>
    </Footer>

    <Hr />
    <WarningTextBlock remunerativeInterestRate={item.monthlyInterestRate} />
  </ItemInvoice>
)

const WarningTextBlock = ({ remunerativeInterestRate }) => (
  <Center>
    <WarningText>
      •
      {remunerativeInterestRate
        ? ` O atraso no pagamento acarretará a incidência de juros de mora de 1% ao mês (pro rata temporis), juros remuneratórios de ${remunerativeInterestRate}% ao mês, e multa de 2% sobre o total devido, incluindo os encargos.`
        : ' Nas faturas em atraso são aplicadas taxas de 2% de multa + mora de 0,033% ao dia'}
      <Br />
      • Ao gerar uma segunda via, a data de vencimento é sempre o dia seguinte <Br />
    </WarningText>
  </Center>
)
